class ImagePoints extends HTMLElement {
  connectedCallback() {
    this.images = this.querySelectorAll('.image-points__image');
    this.texts = this.querySelectorAll('.image-points__text');
    this.dots = this.querySelectorAll('.image-points__dot');
    this.controls = this.querySelectorAll('.image-points__controls button');

    this.bindEvents();
  }

  bindEvents() {
    [...this.dots, ...this.controls].forEach(button => {
      button.addEventListener('click', () => {
        this.activate(button.dataset.index);
      });
    });
  }

  activate(index) {
    this.images.forEach(el => el.classList.remove('active'));
    this.texts.forEach(el => el.classList.remove('active'));
    this.dots.forEach(el => el.classList.remove('active'));
    this.controls.forEach(el => el.classList.remove('active'));

    this.images[index].classList.add('active');
    this.texts[index].classList.add('active');

    this.dots.forEach(dot => {
      if (dot.dataset.index === index) {
        dot.classList.add('active');
      }
    });

    this.controls[index].classList.add('active');
  }
}

customElements.define('image-points', ImagePoints);